<!-- structure-graph-pie-simple.component.html -->
<div class="chart-container">
  <apx-chart
    *ngIf="isValidGraphOptions"
    [series]="graphOptions.series"
    [chart]="graphOptions.chart"
    [labels]="graphOptions.labels"
    [legend]="graphOptions.legend"
    [tooltip]="graphOptions.tooltip"
    [colors]="graphOptions.colors"
    [responsive]="graphOptions.responsive">
  </apx-chart>
  <div *ngIf="!isValidGraphOptions" class="no-data">
    Нет данных для отображения графика
  </div>
</div>
